import DesignTokens from '@tableau/design-tokens';
import React from 'react';

import { applyColor } from '~src/style/ColorService';

import { IconBaseProps } from './IconBaseProps';

const WarningIcon = (props: IconBaseProps) => (
  // tslint:disable:max-line-length
  <svg
    width={11}
    height={10}
    {...props}
  >
    <defs>
      <path
        id='prefix__a'
        d='M4.876.374c.292-.499 1.021-.499 1.24 0l4.811 8.556c.22.5-.073 1.07-.656 1.07H.721c-.51 0-.875-.57-.656-1.07L4.876.374zm.146 2.496v4.278h1.094V2.87H5.022zm0 4.991v.713h1.094v-.713H5.022z'
      />
    </defs>
    <use fill={applyColor(DesignTokens.color.font.default.error, '#C41723')} fillRule='evenodd' xlinkHref='#prefix__a' />
  </svg>
  // tslint:enable:max-line-length
);

export { WarningIcon };
